let PackagesItem = [
    {
        track: 'Junior',
        trackJunior: true,
        trackTitle: "Junior Track",
        trackSubtitle: true,
        trackPrice: "0",
        runningString: true,
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticketfree/1675699623903x887689248045269000',
        // juniorTicket1Name: "Free Ticket",
        // juniorTicket1Price: "0.00",
        // juniorTicket1Link: "https://geekle.us/ticketfree/1675699623903x887689248045269000",
        // juniorTicket2Name: "+ Certificate",
        // juniorTicket2Price: "9.99",
        // juniorTicket2Link: "https://geekle.us/ticket/1699050980589x744788592922460200",
        // juniorTicket3Name: "+ Certificate & Recordings",
        // juniorTicket3Price: "15.99",
        // juniorTicket3Link: "https://geekle.us/ticket/1699052148943x968070139451801600",
    },
    {
        track: 'Full Access',
        trackFull: true,
        trackTitle: "FULL ACCESS 🔥",
        trackSubtitle: "ticket",
        runningString: true,
        trackPrice: "169",
        earlyBird: "early birds price",
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Junior and Senior Track Access',
        trackLink: 'https://geekle.us/ticket/1675699323957x469292402673713150',
    },
    {
        track: 'Year',
        trackTitle: "YEAR OF FLUTTER ❤️",
        trackSubtitle: "package",
        runningString: true,
        trackPrice: "249",
        earlyBird: "one year access",
        trackDesc: "1",
        trackText: true,
        yearTrackText: true,
        trackText1: "One Year Package",
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticket/1697476702448x159755542784114700',
    },
    {
        track: 'Premium',
        newPremium: true,
        trackTitle: "GEEKLE PREMIUM",
        trackSubtitle: "MEMBERSHIP",
        trackPriceApperance: 2,
        trackPrice: "399",
        trackText: true,
        trackText1: "One Year Premium Membership",
        trackDesc: "1",
        trackButton: "BUY",
        trackLink: 'https://geekle.us/ticket/1696847842733x949907249339039700',
        inverseColors: true,
    },
    // {
    //     trackTitle: "TEAM-5",
    //     trackSubtitle: "YEAR GROUP PACKAGE",
    //     trackPriceApperance: 3,
    //     runningString: true,
    //     trackPrice: "999",
    //     trackText: true,
    //     trackText1: "One Year Pass for 5 team members",
    //     trackDesc: "1",
    //     trackButton: "BUY",
    //     trackLink: 'https://geekle.us/ticket/1694109810106x843614570263085000',
    // },
    // {
    //     trackMode: 'Halloween',
    //     trackTitle: "FRANKENSTEIN'S HALLOWEEN 3+1 PACK",
    //     trackSubtitle: true,
    //     trackPrice: "179",
    //     trackText: true,
    //     trackButton: "GRAB SPOOKY DEAL",
    //     trackLink: 'https://geekle.us/ticket/1698044453451x220433225697198100',
    // },
    {
        track: 'Unlimited',
        trackTitle: "UNLIMITED",
        trackSubtitle: "YEAR ENTERPRISE PACKAGE",
        trackPriceApperance: 4,
        runningString: true,
        trackPrice: "Ask Our Manager",
        trackText: true,
        trackText1: "One Year Pass for up to 100 members",
        trackDesc: "1",
        trackButton: "Get Offer",
        trackLink: 'enterprise',
        validDate: '9.06',
    },
];

export default PackagesItem;
